import React from "react";
import { InboxIcon } from "@heroicons/react/24/outline";

const EmptyList = ({ message = "No items found", children = undefined }) => {
    return (
        <div className="flex flex-col items-center justify-center py-10 px-4 text-center text-gray-500">
            {/* Default Icon */}
            <InboxIcon className="w-12 h-12 text-gray-400 mb-3" />

            {/* Message */}
            <p className="text-sm md:text-base font-medium">{message}</p>

            {/* Optional extra actions (like a button) */}
            {children && <div className="mt-4">{children}</div>}
        </div>
    );
};

export default EmptyList;
